module.exports = __webpack_public_path__ + "static/media/well-controlled-asthma-scale-background-kids.3a98aa89.svg";